import { UpdateCampaignSchemaFrontend } from "modules/campaigns/hooks/useCampaignForm"
import { useMemo } from "react"
import { UseFormReturn } from "react-hook-form"
import { z } from "zod"

const normalizeLanguageCode = (language: string) => {
  if (!language) return ""
  return language.split("-")[0]?.split("_")[0]?.toLowerCase()
}

export function useChannelWarnings(
  form: UseFormReturn<z.infer<typeof UpdateCampaignSchemaFrontend>>,
) {
  const defaultLanguage = form.watch("defaultLanguage")
  const templates = form.watch("templates")

  const shouldShowLanguageWarning = useMemo(() => {
    if (!defaultLanguage || !templates || templates.length === 0) return false

    return !templates.some(
      (template) =>
        normalizeLanguageCode(template.language) === normalizeLanguageCode(defaultLanguage),
    )
  }, [defaultLanguage, templates])

  const shouldShowDefaultLanguageMissingWarning = useMemo(() => {
    if (!templates || templates.length === 0) return false
    return !defaultLanguage
  }, [defaultLanguage, templates])

  return {
    shouldShowLanguageWarning,
    shouldShowDefaultLanguageMissingWarning,
  }
}
